import {h} from 'preact';

function Button({showInfo, checked, fetching, onChange}) {
    return (
        <div className="oViewedCheckButton__Wrapper">
            {<button
                title={!showInfo ? 'Passez par le login pour marquer vos contenus favoris et vos contenus consultés sur la plateforme' : null}
                className={'oViewedCheckButton aActionButton' + (checked ? ' aActionButton--Checked' : '')}
                value={checked} onClick={onChange} disabled={fetching || !showInfo}>
                <span className="aActionButton__Inner">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.2" height="14.2" viewBox="0 0 14.2 14.2">
                        <g>
                        <path className="sVu" fill="#323232" d="M2.2,7.1L5,10.8l7-9.6L13,2L5,13l-3.9-5L2.2,7.1z"/>
                        </g>
                    </svg>
                </span>
            </button>}
        </div>
    )
}

export default Button
